export const downloadPlatforms = [
    {
        id: 1,
        name: 'گوگل پلی',
        source: "images/google-play.svg",
        alt: "google-play"
    }, {
        id: 2,
        name: 'بازار',
        source: "images/cafee-bazaar.svg",
        alt: "cafee-bazaar"
    }, {
        id: 3,
        name: 'مایکت',
        source: "images/myket.svg",
        alt: "myket"
    }, {
        id: 4,
        name: 'چارخونه',
        source: "images/chaarkhoone.svg",
        alt: "chaarkhoone"
    }, {
        id: 5,
        name: 'اپ گالری',
        source: "images/appGallery.svg",
        alt: "appGallery"
    }
]

export const genders = [
    {
        id: 1,
        title: "زن",
        value: "female"
    },
    {
        id: 2,
        title: "مرد",
        value: "male"
    }
];
export const maritalStatuses = [
    {
        id: 1,
        value: "single",
        title: "مجرد",
    },
    {
        id: 2,
        value: "married",
        title: "متاهل"
    },
    {
        id: 3,
        value: "divorced",
        title: "متارکه"
    }
];
export const degrees = [
    {
        id: 0,
        title: "زیر دیپلم",
        value: "ill"
    },
    {
        id: 1,
        title: "سیکل",
        value: "sik"
    },
    {
        id: 2,
        title: "دیپلم",
        value: "dip"
    }, {
        id: 3,
        title: "فوق دیپلم",
        value: "ass"
    }, {
        id: 4,
        title: "کارشناسی",
        value: "bach"
    }, {
        id: 5,
        title: "کارشناسی ارشد",
        value: "mast"
    }, {
        id: 6,
        title: "دکترا",
        value: "phd"
    }
];

export const jobs = [
    {
        id: 1,
        title: "پزشک"
    },
    {
        id: 2,
        title: "کارمند دولت"
    }, {
        id: 3,
        title: "کارمند بانک"
    },
    {
        id: 4,
        title: "کارمند شرکت خصوصی"
    }, {
        id: 5,
        title: "آزاد"
    }, {
        id: 6,
        title: "وکیل"
    }, {
        id: 7,
        title: "دانشجو"
    }, {
        id: 8,
        title: "خانه دار"
    }
];

export const income = [
    {
        id: 1,
        title: "۱۰ - ۵"
    },
    {
        id: 2,
        title: "۱۵ - ۱۰"
    },
    {
        id: 3,
        title: "۲۰ - ۱۵"
    },
    {
        id: 4,
        title: "۲۵ - ۲۰"
    },
    {
        id: 5,
        title: " ۲۵ به بالا"
    },
];

export const deliveryLocations = [
    {
        id: 1,
        title: "تحویل از آدرس محل سکونت"
    },
    {
        id: 2,
        title: "تحویل از آدرس محل کار"
    }
]

let date = new Date();
const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
// date.setDate(date.getDate() + 7);
const mydate = date.toLocaleDateString('fa', options)

export const listOfOffices = [
    {
        id: 1,
        title: "دفتر شماره ۱:",
        description: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی"
    },
    {
        id: 2,
        title: "دفتر شماره ۲:",
        description: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی"
    },
    {
        id: 3,
        title: "دفتر شماره ۳:",
        description: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی"
    }
]

export function timeConverter(num) {
    let minutes = Math.floor((num / 60));
    let decimalTime = num - (minutes * 60);
    let seconds = Math.round(decimalTime);
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return minutes + ":" + seconds
}

export function convertHoursToDaysAndHours(hours) {
    var days = Math.floor(hours / 24); // Get the whole number of days
    var remainingHours = hours % 24; // Get the remaining hours
    return days + " روز" + " و " + remainingHours + "ساعت";
}

export function formattedDate(originalDateString) {
    if (!originalDateString) return;
    const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
        hour12: false,
    };
    return new Intl.DateTimeFormat('fa-IR', options).format(new Date(originalDateString));
}

export function formattedFullDate(dateString) {
    if (!dateString) return;
    const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: "numeric",
        timeZone: 'UTC'
    };
    return new Intl.DateTimeFormat('fa-IR', options).format(new Date(dateString));
}

// Function to convert Farsi numbers to English numbers
export const convertToEnglishNumbers = (value) => {
    if (!value) {
        return value;
    }

    const farsiNumbers = '۰۱۲۳۴۵۶۷۸۹';
    const englishNumbers = '0123456789';

    // Create a mapping for Farsi to English numbers
    const farsiToEnglishMap = {};
    for (let i = 0; i < 10; i++) {
        farsiToEnglishMap[farsiNumbers[i]] = englishNumbers[i];
    }

    // Replace Farsi numbers with English numbers and remove other Farsi characters
    const convertedString = value?.replace(/[۰-۹]/g, match => farsiToEnglishMap[match] || '');

    return convertedString;

};